/** @module faq */

/**
 * Initializes FAQ functionalities. Checks for FAQ containers and initializes
 * multi-expand functionality and filter integration.
 *
 * @param {object} [options={}] - Options for the FAQ.
 *
 * @return {Promise<void>} - Resolves immediately, if no FAQ container is on the page, or once
 * functionality is all set up.
 */
export async function faq(options = {}) {
    // Check for FAQ container instead of filter buttons
    if (document.querySelector('.content-band--faq')) {
        const { initFaq } = await import(/* webpackMode: "lazy" */ './inc/faq.async.js');

        initFaq(options);
    }
}
